<form [formGroup]="form">
  <h3-attribute-display-label
    [attribute]="attribute"
    [annotationStore]="annotationStore"
    [attributeValue]="attributeValue$ | async"
    [ngClass]="{ clickable: (isReadOnly$ | async) === false }"
    (click)="focusIn()"
    *ngIf="!isFocused"
  >
    <div class="subtitle-03 attribute-value">
      {{ (attributeLabel$ | async) || '-' }}
    </div></h3-attribute-display-label
  >

  <div
    class="input-container"
    *ngIf="isFocused"
    #inputContainer
    (focusout)="focusOut($event)"
  >
    <div class="caption">
      <span>{{ attribute.name }}</span>
      <mat-icon (click)="clearValue()" tabindex="1">refresh</mat-icon>
    </div>
    <mat-form-field subscriptSizing="dynamic">
      <mat-select
        formControlName="input"
        #inputArea
        tabindex="1"
        [multiple]="multiple"
        (close)="inputArea.focus()"
        (selectionChange)="onSelectionChange($event.value)"
      >
        @for (option of options | keyvalue; track option) {
          <!-- inline css to avoid ng-deep or ViewEncapsulation.None -->
          <mat-option
            style="height: 40px; min-height: 40px"
            [value]="option.value.value"
            >{{ option.value.label }}</mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>
</form>
